import View from "../../../Nav/Js/views/PubliFlipCard";
import components from "./components.js";
components.define("js-PubliFlipCard", View);